<div class="flex flex-col gap-4 w-2/3">

  <!-- Table actions card -->
  <div class="ec-category-header">{{ 'settings.system.tableactions' | translate }}</div>
  <app-card>

    <!-- Export to file -->
    <div class="mb-4">
      <label class="ec-toggle-label">
        {{ 'settings.system.tableexport' | translate }}
        <app-toggle
          [(ngModel)]="tableExport"
          (ngModelChange)="onTableExportChange($event)"
        ></app-toggle>
      </label>
      <p class="text-xs text-gray-400 mt-1 px-1">
        {{ 'settings.system.tableexportinfo' | translate }}
      </p>
    </div>

    <!-- Export to clipboard -->
    <div>
      <label class="ec-toggle-label">
        {{ 'settings.system.tableclipboard' | translate }}
        <app-toggle
          [(ngModel)]="tableClipboard"
          (ngModelChange)="onTableClipboardChange($event)"
        ></app-toggle>
      </label>
      <p class="text-xs text-gray-400 mt-1 px-1">
        {{ 'settings.system.tableclipboardinfo' | translate }}
      </p>
    </div>

  </app-card>

  <!-- Display card -->
  <div class="ec-category-header">{{ 'settings.system.tabledisplay' | translate }}</div>
  <app-card>

    <!-- Floating table header -->
    <div>
      <label class="ec-toggle-label">
        {{ 'settings.system.floatingtableheader' | translate }}
        <app-toggle
          [(ngModel)]="floatingTableHeader"
          (ngModelChange)="onFloatingTableHeaderChange($event)"
        ></app-toggle>
      </label>
      <p class="text-xs text-gray-400 mt-1 px-1">
        {{ 'settings.system.floatingtableheaderinfo' | translate }}
      </p>
    </div>

  </app-card>

  <!-- Saved table configurations card -->
  <div class="ec-category-header">{{ 'settings.system.tableconfigurations' | translate }}</div>
  <app-card>

    @if (tableSettings.length > 0) {
      <div class="flex flex-col gap-3">
        @for (element of tableSettings; track element.tableId) {
          <div class="bg-gray-50 dark:bg-dark-hover flex justify-between items-center py-2 px-3 rounded w-full">
            <span>{{ (element.settings.title ?? element.tableId) | translate }}</span>
            <a
              href="#"
              class="text-gray-400 dark:text-dark-muted hover:text-red-500 transition-colors duration-150"
              (click)="$event.preventDefault(); clearTableConfiguration(element.tableId)"
              [title]="'common.reset' | translate"
            >
              <lucide-angular [name]="Trash" size="16"></lucide-angular>
            </a>
          </div>
        }
        <div class="text-right mt-1">
          <a href="#" (click)="$event.preventDefault(); clearTableConfigurations()"
             class="text-sm text-gray-500 dark:text-dark-muted underline">
            {{ 'common.resetall' | translate }}
          </a>
        </div>
      </div>
    } @else {
      <div class="text-sm font-semibold text-gray-400 dark:text-dark-muted text-center py-2">
        {{ 'settings.system.notableconfiguration' | translate }}
      </div>
    }
  </app-card>

</div>
